import type { PDFReader } from "./PDFReader"
import type { PDFReaderOptions } from "./PDFReaderOptions"
import type { PDFWriter } from "./PDFWriter"

export type PDFSession = {
  reader: (options: PDFReaderOptions) => Promise<PDFReader>
  writer: () => Promise<PDFWriter>
}

export type PDFSessionFactory = <T = void>(
  func: (api: PDFSession) => Promise<T>
) => Promise<T>
